<template>
  <v-container>
    <back-button></back-button>
    <page-heading>{{ pageTitle }}</page-heading>
    <ajax-table
      ref="notificationsTable"
      resource="notifications"
      :headers="[
        {text: 'notifications.statusLabel', value: 'status'},
        {text: 'notifications.message', value: 'message'},
        {text: 'notifications.context', value: 'context', sortable: false},
        {text: 'notifications.notifiedCount', value: 'notifiedCount'},
        {text: 'notifications.lastNotifiedAt', value: 'lastNotifiedAt', dateTimeFormat: 'fromNow'},
        {text: 'notifications.silentUntil', value: 'silentUntil', dateTimeFormat: 'fromNow'},
        {text: '', value: 'actions', sortable: false},
      ]"
      :page-options="{itemsPerPage: 20, sortBy: ['lastNotifiedAt'], sortDesc: [true]}"
    >
      <template v-slot:item.status="{ item }">
        <notification-status :notification="item" />
      </template>
      <template v-slot:item.message="{ item }">
        <div class="mt-1">{{ getReadableNotificationType(item) }}</div>
        <div style="font-size: 0.9em;" class="grey--text text--darken-1">{{ item.message }}</div>
      </template>
      <template v-slot:item.context="{ item }">
        <template v-if="item.booking && item.booking.id">
          {{ transSingular('booking.booking') }}
          <span style="white-space: nowrap;"><booking-id :value="item.booking.id" :open-in-new-tab="false" /></span>
        </template>
        <template v-else-if="item.object && item.object.id">
          <object-name :value="item.object" :open-in-new-tab="false" />
        </template>
      </template>
      <template v-slot:item.notifiedCount="{ item }">
        <v-chip small>
          {{ item.notifiedCount }}
        </v-chip>
      </template>
      <template v-slot:item.silentUntil="{ item }">
        <span
          v-if="item.status === 'SILENCED' && item.silentUntil"
          :title="formatDate(item.silentUntil, 'LLL')"
        >{{ formatFromNow(item.silentUntil) }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <notification-context-menu :notification="item" @update="loadData" />
      </template>
    </ajax-table>
  </v-container>
</template>

<script>
import AjaxTable from '@/components/AjaxTable';
import PageHeading from '@/components/PageHeading';
import {LocaleUtils} from '@/utils/locale-utils';
import {NotificationUtils} from '@/utils/notification-utils';
import BackButton from '@/components/BackButton';
import NotificationContextMenu from '@/components/notifications/NotificationContextMenu';
import NotificationStatus from '@/components/notifications/NotificationStatus';
import {DateUtils} from '@/utils/date-utils';
import BookingId from '@/components/BookingId';
import ObjectName from '@/components/ObjectName';

export default {
  name: 'NotificationsPage',
  mixins: [
    LocaleUtils,
    NotificationUtils,
    DateUtils
  ],
  components: {
    ObjectName,
    BookingId,
    NotificationStatus,
    NotificationContextMenu,
    BackButton,
    PageHeading,
    AjaxTable
  },
  computed: {
    pageTitle () {
      return this.transPlural('notifications.notification');
    }
  },
  methods: {
    loadData () {
      this.$refs.notificationsTable.loadData();
      this.getActiveNotifications();
    }
  }
}
</script>

<style scoped>

</style>
